<template>
    <div class="search-box" :class="compact && 'is-compact'">
        <i class="bi bi-search icon" aria-hidden="true"></i>
        <!-- Callers must pass aria-label (or aria-labelledby); it reaches the input via $attrs,
             which the a11y rule can't statically see. -->
        <!-- eslint-disable-next-line vuejs-accessibility/form-control-has-label -->
        <input v-model="model" type="text" v-bind="$attrs" />
    </div>
</template>

<script lang="ts">
interface BaseSearchInputProps {
    // Narrow header/inline variant instead of the default full-width block.
    compact?: boolean;
}
</script>

<script setup lang="ts">
defineOptions({ inheritAttrs: false });

defineProps<BaseSearchInputProps>();

const model = defineModel<string>({ default: "" });
</script>

<style scoped>
@reference "../../../../css/tailwind.css";

@layer components {
    .search-box {
        @apply flex w-full items-center gap-2.5 rounded-md border border-control-border bg-control-bg p-2.5 transition-colors focus-within:border-control-border-focus;
    }

    .search-box.is-compact {
        @apply w-64 px-2.5 py-2;
    }

    .search-box .icon {
        @apply text-base/none text-control-text shrink-0;
    }

    .search-box input {
        @apply min-w-0 flex-1 border-none bg-transparent outline-none scaffold-body-small text-control-text-strong placeholder:text-control-placeholder;
    }
}
</style>
